import React from 'react';
import { InstagramIcon, FacebookIcon, LinkedinIcon } from 'lucide-react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../contexts/LanguageContext';
import { openCalendlyPopup } from '../utils/calendly';
export function Footer() {
  const {
    t
  } = useLanguage();
  const footerLinks = {
    company: [{
      label: t('footer.contact'),
      href: '#',
      isCalendly: true
    }],
    legal: [{
      label: t('footer.privacy'),
      href: '/datenschutz'
    }, {
      label: t('footer.imprint'),
      href: '/impressum'
    }]
  };
  const handleCalendlyClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    openCalendlyPopup();
  };
  return <footer className="bg-[#0a0e1a] border-t border-white/5" data-id="element-182">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 lg:py-16" data-id="element-183">
        <div className="grid grid-cols-2 md:grid-cols-3 gap-8 lg:gap-12" data-id="element-184">
          {/* Brand */}
          <div className="col-span-2 md:col-span-1" data-id="element-185">
            <Link to="/" className="flex items-center gap-2 mb-4" data-id="element-186">
              <span className="text-xl font-bold text-white" data-id="element-187">CRM</span>
              <span className="text-xl font-bold text-[#ff6b35]" data-id="element-188">Kraft</span>
            </Link>
            <p className="text-gray-400 text-sm mb-6" data-id="element-189">{t('footer.tagline')}</p>
            <div className="flex gap-4" data-id="element-190">
              <a href="https://www.instagram.com/kraftjustus/" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-[#ff6b35] transition-colors" data-id="element-191">
                <InstagramIcon className="w-5 h-5" data-id="element-192" />
              </a>
              <a href="https://www.facebook.com/kraftjustus" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-[#ff6b35] transition-colors" data-id="element-193">
                <FacebookIcon className="w-5 h-5" data-id="element-194" />
              </a>
              <a href="https://www.linkedin.com/in/justus-kraft/" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-[#ff6b35] transition-colors" data-id="element-195">
                <LinkedinIcon className="w-5 h-5" data-id="element-196" />
              </a>
            </div>
          </div>

          {/* Company Links */}
          <div data-id="element-197">
            <h4 className="text-white font-semibold mb-4" data-id="element-198">
              {t('footer.company')}
            </h4>
            <ul className="space-y-3" data-id="element-199">
              {footerLinks.company.map(link => <li key={link.label} data-id="element-200">
                  <a href={link.href} onClick={handleCalendlyClick} className="text-gray-400 hover:text-white text-sm transition-colors cursor-pointer" data-id="element-201">
                    {link.label}
                  </a>
                </li>)}
            </ul>
          </div>

          {/* Legal Links */}
          <div data-id="element-202">
            <h4 className="text-white font-semibold mb-4" data-id="element-203">
              {t('footer.legal')}
            </h4>
            <ul className="space-y-3" data-id="element-204">
              {footerLinks.legal.map(link => <li key={link.label} data-id="element-205">
                  <Link to={link.href} className="text-gray-400 hover:text-white text-sm transition-colors" data-id="element-206">
                    {link.label}
                  </Link>
                </li>)}
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-12 pt-8 border-t border-white/5 text-center" data-id="element-207">
          <p className="text-gray-500 text-sm" data-id="element-208">{t('footer.copyright')}</p>
        </div>
      </div>
    </footer>;
}